import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid } from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import SlideUpTransition from "./fundamentals/SlideUpTransition";
import ConfirmButton from "./fundamentals/ConfirmButton";

const ViewCommentsDialog = (props) => {
  return (
    <Dialog
      PaperProps={{
        sx: {
          width: "500px",
          maxWidth: "90vw",
          margin: "auto",
          whiteSpace: "pre-line",
          wordWrap: "break-word",
        },
      }}
      open={props.isDialogOpen}
      TransitionComponent={SlideUpTransition}
      keepMounted
      onClose={props.handleClickDialogClose}
      publishedTimestamp={props.publishedTimestamp}
    >
      <DialogTitle id="alert-dialog-slide-title">
        {props.header + " "}
        {props.publishedTimestamp}
      </DialogTitle>
      <DialogContent>
        <DialogContentText component={"div"} id="alert-dialog-slide-description">
          <Grid container>
            <Grid item xs={12}>
              {props.message}
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <ConfirmButton variant="contained" color="primary" onClick={props.handleClickDialogClose}>
          OK
        </ConfirmButton>
      </DialogActions>
    </Dialog>
  );
};

ViewCommentsDialog.propTypes = {
  isDialogOpen: PropTypes.bool.isRequired,
  handleClickDialogClose: PropTypes.func.isRequired,
  header: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  publishedTimestamp: PropTypes.string.isRequired,
};

export default ViewCommentsDialog;
